/* Progressive enhancements over native Shopify links and forms. No dependencies. */
(() => {
  'use strict';
  if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;

  const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  const openers = new WeakMap();
  const open = (dialog, opener) => {
    document.querySelector('[data-mobile-menu]')?.removeAttribute('open');
    openers.set(dialog, opener);
    if (!dialog.open) dialog.showModal();
    (dialog.querySelector('input[type="search"]') || dialog.querySelector('[data-close-dialog]'))?.focus();
    if (dialog.id === 'SearchDialog') dialog.querySelector('input[type="search"]').dispatchEvent(new Event('input'));
  };
  const close = dialog => {
    dialog.close();
  };
  document.querySelectorAll('.shop-dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-close-dialog]')) close(dialog);
      else if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(dialog);
      }
    });
    dialog.addEventListener('close', () => {
      const opener = openers.get(dialog);
      if (opener?.isConnected && !document.querySelector('.shop-dialog[open]')) opener.focus();
    });
  });

  const cart = document.querySelector('zs-cart');
  const cartDialog = cart?.querySelector('dialog');
  let cartBusy = false;
  let cartRead = null;
  const cartError = message => {
    const node = cart.querySelector('[data-cart-error]');
    node.textContent = message || '';
    node.hidden = !message;
  };
  const setBusy = busy => {
    cartBusy = busy;
    cartDialog.setAttribute('aria-busy', String(busy));
    cartDialog.querySelectorAll('[data-cart-quantity], button[name="checkout"]').forEach(button => { button.disabled = busy; });
  };
  const renderCart = html => {
    const content = parse(html, '[data-cart-content]');
    if (!content) throw new Error(cart.dataset.error);
    cart.querySelector('[data-cart-content]').replaceWith(content);
    document.querySelectorAll('[data-cart-count]').forEach(count => {
      count.textContent = content.dataset.count;
      count.hidden = Number(content.dataset.count) === 0;
    });
  };
  const readCart = async () => {
    cartRead?.abort();
    cartRead = new AbortController();
    const url = new URL(cart.dataset.cartUrl, location.origin);
    url.searchParams.set('section_id', 'cart-drawer');
    const response = await fetch(url, { signal: cartRead.signal });
    if (!response.ok) throw new Error(cart.dataset.error);
    renderCart(await response.text());
  };
  const refreshCart = async () => {
    if (cartBusy) return;
    setBusy(true);
    cartError('');
    try { await readCart(); }
    catch (error) { if (error.name !== 'AbortError') cartError(cart.dataset.error); }
    finally { setBusy(false); }
  };
  const updateFromResponse = async result => {
    if (result.sections?.['cart-drawer']) renderCart(result.sections['cart-drawer']);
    else await readCart();
  };
  const postCart = async (url, body, json = false) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: json ? JSON.stringify(body) : body,
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || cart.dataset.error);
    return result;
  };

  if (cart) {
    cart.addEventListener('click', async event => {
      const button = event.target.closest('[data-cart-quantity]');
      if (!button || cartBusy) return;
      const key = button.closest('[data-line]').dataset.line;
      const quantity = Number(button.dataset.cartQuantity);
      const previousLines = [...cart.querySelectorAll('[data-line]')];
      const lineIndex = previousLines.indexOf(button.closest('[data-line]'));
      const controlIndex = [...button.closest('[data-line]').querySelectorAll('[data-cart-quantity]')].indexOf(button);
      setBusy(true);
      cartError('');
      try {
        const result = await postCart(cart.dataset.changeUrl, { id: key, quantity, sections: ['cart-drawer'], sections_url: location.pathname }, true);
        await updateFromResponse(result);
        cart.querySelector('[data-cart-status]').textContent = cart.dataset.updated;
        const line = [...cart.querySelectorAll('[data-line]')].find(item => item.dataset.line === key) || cart.querySelectorAll('[data-line]')[Math.max(0, lineIndex - 1)];
        setBusy(false);
        const sameLine = line?.dataset.line === key;
        (line?.querySelectorAll('[data-cart-quantity]')[sameLine ? controlIndex : 0] || cart.querySelector('[data-close-dialog]')).focus();
      } catch (error) { cartError(error.message || cart.dataset.error); }
      finally { setBusy(false); }
    });

    document.addEventListener('submit', async event => {
      const form = event.target.closest('form.product__form');
      if (!form || !event.submitter?.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      if (cartBusy) return;
      const button = event.submitter;
      const errorNode = form.querySelector('[data-product-error]');
      if (errorNode) { errorNode.textContent = ''; errorNode.hidden = true; }
      const body = new FormData(form);
      body.set('sections', 'cart-drawer');
      body.set('sections_url', location.pathname);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      setBusy(true);
      cartError('');
      let added = false;
      try {
        const result = await postCart(cart.dataset.addUrl, body);
        added = true;
        await updateFromResponse(result);
      } catch (error) {
        if (added) cartError(cart.dataset.refreshError);
        else if (errorNode) { errorNode.textContent = error.message || cart.dataset.error; errorNode.hidden = false; errorNode.focus(); }
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = !form.querySelector('[name="id"]')?.value || Boolean(form.querySelector('[name="id"]')?.disabled);
        setBusy(false);
      }
      if (added) {
        const quick = document.getElementById('QuickView');
        const opener = quick?.open ? openers.get(quick) : button;
        if (quick?.open) close(quick);
        cart.querySelector('[data-cart-status]').textContent = cart.dataset.added;
        open(cartDialog, opener);
      }
    });
  }

  let quickRequest;
  document.getElementById('QuickView')?.addEventListener('close', () => quickRequest?.abort());
  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest('[data-open-cart], [data-open-search], [data-quick-view]');
    if (!trigger) return;
    if (trigger.matches('[data-open-cart]') && cart) {
      event.preventDefault();
      open(cartDialog, trigger);
      await refreshCart();
    } else if (trigger.matches('[data-open-search]')) {
      const dialog = document.getElementById('SearchDialog');
      if (!dialog) return;
      event.preventDefault();
      open(dialog, trigger);
    } else if (trigger.matches('[data-quick-view]')) {
      const dialog = document.getElementById('QuickView');
      if (!dialog) return;
      event.preventDefault();
      quickRequest?.abort();
      const request = new AbortController();
      quickRequest = request;
      const content = dialog.querySelector('[data-quick-view-content]');
      const loading = document.createElement('p');
      loading.className = 'shop-dialog__loading';
      loading.setAttribute('role', 'status');
      loading.textContent = dialog.dataset.loading;
      content.replaceChildren(loading);
      dialog.setAttribute('aria-busy', 'true');
      open(dialog, trigger);
      try {
        const url = new URL(trigger.href);
        url.searchParams.set('section_id', 'quick-view');
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error();
        const result = parse(await response.text(), '[data-quick-view-content]');
        if (!result?.querySelector('form')) throw new Error();
        if (request === quickRequest && dialog.open) content.replaceChildren(...result.childNodes);
      } catch (error) {
        if (error.name === 'AbortError' || request !== quickRequest || !dialog.open) return;
        const message = document.createElement('p');
        message.className = 'shop-dialog__error';
        message.textContent = dialog.dataset.error;
        const fallback = document.createElement('a');
        fallback.href = trigger.href;
        fallback.textContent = dialog.dataset.detailsLabel;
        fallback.className = 'btn btn--primary';
        const container = document.createElement('div');
        container.className = 'shop-dialog__fallback';
        container.append(message, fallback);
        content.replaceChildren(container);
      } finally { if (request === quickRequest) dialog.removeAttribute('aria-busy'); }
    }
  });

  const searchInput = document.getElementById('PredictiveSearch');
  if (searchInput) {
    let timer;
    let request;
    const results = document.getElementById('SearchSuggestions');
    const form = searchInput.form;
    const discovery = form.querySelector('[data-search-discovery]');
    const clear = form.querySelector('[data-clear-search]');
    const allResults = form.querySelector('[data-search-all]');
    const updateSearch = () => {
      clearTimeout(timer);
      request?.abort();
      request = null;
      results.replaceChildren();
      results.removeAttribute('aria-busy');
      const query = searchInput.value.trim();
      clear.hidden = !query;
      discovery.hidden = query.length >= 2;
      allResults.hidden = !query;
      if (query.length < 2) return;
      timer = setTimeout(async () => {
        const currentRequest = new AbortController();
        request = currentRequest;
        results.setAttribute('aria-busy', 'true');
        results.textContent = searchInput.dataset.loading;
        try {
          const url = new URL(searchInput.dataset.predictiveUrl, location.origin);
          url.search = new URLSearchParams({ q: query, section_id: 'predictive-search', 'resources[type]': 'product', 'resources[limit]': '5' });
          const response = await fetch(url, { signal: currentRequest.signal });
          if (!response.ok) throw new Error();
          const result = parse(await response.text(), '[data-predictive-results]');
          if (!result) throw new Error();
          if (request === currentRequest) results.replaceChildren(result);
        } catch (error) {
          if (error.name !== 'AbortError' && request === currentRequest) results.textContent = searchInput.dataset.error;
        } finally { if (request === currentRequest) results.removeAttribute('aria-busy'); }
      }, 200);
    };
    searchInput.addEventListener('input', updateSearch);
    clear.addEventListener('click', () => { searchInput.value = ''; updateSearch(); searchInput.focus(); });
    // Seed terms still work as normal search links without JavaScript.
    form.querySelectorAll('.search-dialog__chips a').forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      searchInput.value = new URL(link.href).searchParams.get('q');
      updateSearch();
      searchInput.focus();
    }));
    searchInput.closest('dialog').addEventListener('close', () => { clearTimeout(timer); request?.abort(); results.removeAttribute('aria-busy'); });
  }
})();
